module.exports = __webpack_public_path__ + "static/media/Home.00aa9f64.png";